import customAxios from "../serverCall";

const getEmojiSettings = async () => {
  const response = await customAxios.get(`/admin/emoji/settings`);
  return response;
};

const createEmojiSettings = async (body) => {
  const createData = {
    coins_per_month: body.coins_per_month || 100,
    discount_percentage: body.discount_percentage || 10,
    description: body.description || "Emoji subscription monthly pricing",
    is_active: body.is_active !== undefined ? body.is_active : true,
  };
  const response = await customAxios.post(`/admin/emoji/settings/create`, createData);
  return response;
};

const updateEmojiSettings = async (body) => {
  const updateData = {
    coins_per_month: body.coins_per_month,
    discount_percentage: body.discount_percentage,
    description: body.description,
  };
  const response = await customAxios.put(`/admin/emoji/settings/update`, updateData);
  return response;
};

const EmojiService = {
  getEmojiSettings,
  createEmojiSettings,
  updateEmojiSettings,
};

export default EmojiService;

